// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__9PS67","choiceBoxes":"toolbarselects_choiceBoxes__-KDlH","simpleField":"toolbarselects_simpleField__3OhWw"};